<template>
	<div class="search">
		<el-input :placeholder="default_placeholder" clearable size="mini" v-model="keyword" suffix-icon="el-icon-search" @change="goSearch">
		</el-input>
	</div>
</template>
<script>
	export default {
		name: 'cardSearch',
		props: {
			placeholder: String,
			// keywords:String
		},
		data() {
			return {
				default_placeholder: this.placeholder ? this.placeholder : "请输入内容",
				keyword: "",
			}
		},
		methods: {
			goSearch() {
				console.log(this.keyword)
				this.$emit("search", this.keyword)
			},
		}
	}
</script>

<style>
</style>